import { jsx } from 'react/jsx-runtime';
import '../../../utils/index_orig/index.esm.js';
import '../../../utils/theme/theme-provider/index.esm.js';
import styles from '../../../styles/uitk-egds-badge.css';
import { classNames } from '../../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
/**
 * @deprecated do not use
 */
const EGDSFloatingDotNotificationBadge = props => {
  const {
    className,
    visible
  } = props;
  const baseClassName = 'uitk-badge-floating-dot-notification';
  const wrapperClassNames = getClassNameList(baseClassName, visible && `${baseClassName}-is-visible`, className);
  return jsx("div", {
    className: wrapperClassNames
  });
};
EGDSFloatingDotNotificationBadge.defaultProps = {
  visible: true
};
EGDSFloatingDotNotificationBadge.displayName = 'EGDSFloatingDotNotificationBadge';
export { EGDSFloatingDotNotificationBadge };